module.exports = __webpack_public_path__ + "img/thumbnail.530df3b9.jpg";